import { render, staticRenderFns } from "./PaymentResult.vue.js?vue&type=template&id=0dd734b6!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PaymentResult.vue?vue&type=template&id=0dd734b6"
import script from "./PaymentResult.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PaymentResult.vue?vue&type=script&lang=js"
export * from "./PaymentResult.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PaymentResult.vue?vue&type=script&lang=js"
import style0 from "./PaymentResult.vue.less?vue&type=style&index=0&id=0dd734b6&prod&lang=less!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PaymentResult.vue?vue&type=style&index=0&id=0dd734b6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports